<template>
  <div class="record-list-container">
    <!-- 搜索和操作区域 -->
    <div class="search-bar">
      <el-input v-model="searchForm.keyword" placeholder="请输入名称、手机号、微信号等" clearable size="large"
        style="width: 350px; margin-right: 15px" @keyup.enter="handleSearch">
        <template #prefix>
          <el-icon>
            <Search />
          </el-icon>
        </template>
      </el-input>

      <el-button type="primary" size="large" @click="handleSearch">
        <el-icon>
          <Search />
        </el-icon>
        搜索
      </el-button>

      <el-button type="success" size="large" @click="openAddDialog" style="float: right">
        <el-icon>
          <Plus />
        </el-icon>
        新增号码
      </el-button>

      <el-button type="warning" size="large" @click="openBatchImportDialog" style="margin-left: 10px; float: right">
        <el-icon>
          <Upload />
        </el-icon>
        批量导入
      </el-button>
    </div>

    <!-- 号码记录列表 -->
    <el-table :data="recordList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
      <el-table-column prop="name" label="名称" width="150" />
      <el-table-column prop="phone_number" label="手机号" width="130" />
      <el-table-column prop="wechat" label="微信号" width="150" />
      <el-table-column prop="qq" label="QQ号" width="120" />
      <el-table-column prop="email" label="邮箱" width="180" />
      <el-table-column prop="description" label="描述" width="200" />
      <el-table-column prop="use_num" label="使用次数" width="100" align="center">
        <template #default="{ row }">
          <el-tag :type="row.use_num > 0 ? 'success' : 'info'">
            {{ row.use_num }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80" align="center">
        <template #default="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'danger'">
            {{ row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="notes" label="备注" width="150" />
      <el-table-column prop="create_time" label="创建时间" width="180" />
      <el-table-column prop="update_time" label="更新时间" width="180" />

      <el-table-column label="操作" width="250" fixed="right">
        <template #default="scope">
          <el-button type="success" size="small" @click="handleIncrementUse(scope.row)" v-if="scope.row.status === 1">
            <el-icon>
              <Check />
            </el-icon>
            使用
          </el-button>
          <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
            <el-icon>
              <Edit />
            </el-icon>
            编辑
          </el-button>
          <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
            <el-icon>
              <Delete />
            </el-icon>
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
        :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
        @size-change="fetchRecordList" @current-change="fetchRecordList" />
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="700px" :close-on-click-modal="false">
      <el-form ref="recordForm" :model="recordForm" label-width="120px" :rules="formRules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="recordForm.name" placeholder="请输入名称" size="large" />
        </el-form-item>

        <el-form-item label="手机号" prop="phone_number">
          <el-input v-model="recordForm.phone_number" placeholder="请输入手机号" size="large" />
        </el-form-item>

        <el-form-item label="微信号">
          <el-input v-model="recordForm.wechat" placeholder="请输入微信号" size="large" />
        </el-form-item>

        <el-form-item label="QQ号">
          <el-input v-model="recordForm.qq" placeholder="请输入QQ号" size="large" />
        </el-form-item>

        <el-form-item label="邮箱">
          <el-input v-model="recordForm.email" placeholder="请输入邮箱" size="large" />
        </el-form-item>

        <el-form-item label="状态">
          <el-radio-group v-model="recordForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="描述">
          <el-input v-model="recordForm.description" placeholder="请输入描述信息" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input v-model="recordForm.notes" placeholder="请输入备注信息" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRecordForm">确认</el-button>
      </template>
    </el-dialog>
    <!-- 数据预览对话框 -->
    <el-dialog v-model="previewDialogVisible" title="导入数据预览" width="900px">
      <el-alert type="info" show-icon style="margin-bottom: 15px;">
        预览前10条数据，共 {{ importData.length }} 条记录
      </el-alert>

      <el-table :data="previewData" border stripe height="400">
        <el-table-column prop="name" label="名称" width="120" />
        <el-table-column prop="phone_number" label="手机号" width="130" />
        <el-table-column prop="wechat" label="微信号" width="120" />
        <el-table-column prop="qq" label="QQ号" width="100" />
        <el-table-column prop="email" label="邮箱" width="150" />
        <el-table-column prop="description" label="描述" width="150" />
        <el-table-column prop="notes" label="备注" width="120" />
      </el-table>

      <template #footer>
        <el-button @click="previewDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>
    <!-- 批量导入对话框 -->
    <el-dialog v-model="importDialogVisible" title="批量导入号码记录" width="500px" :close-on-click-modal="false">
      <el-tabs v-model="importActiveTab">
        <el-tab-pane label="Excel导入" name="excel">
          <el-upload class="upload-demo" drag ref="excelUploadRef" action="" :auto-upload="false"
            :on-change="handleExcelChange" accept=".xlsx,.xls" :limit="1">
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
            <template #tip>
              <div class="el-upload__tip">请上传Excel文件，支持.xlsx和.xls格式</div>
              <div style="margin-top: 20px; text-align: center;">
                <el-button type="text" @click="downloadTemplate">
                  <el-icon>
                    <Download />
                  </el-icon>
                  下载Excel模板
                </el-button>
              </div>
            </template>
          </el-upload>
        </el-tab-pane>
      </el-tabs>

      <template #footer>
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button @click="previewImportData" :disabled="importData.length === 0">预览数据</el-button>
        <el-button type="primary" @click="submitBatchImport">确认导入</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import * as XLSX from 'xlsx'
import {
  Search, Plus, Edit, Delete, UploadFilled, Download, Check
} from '@element-plus/icons-vue'

export default {
  name: 'NumberRecordView',
  components: { Search, Plus, Edit, Delete, UploadFilled, Download, Check },
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    storeId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      previewDialogVisible: false,
      previewData: [],
      importDialogVisible: false,
      importActiveTab: 'excel',
      importFile: null,
      importData: [],
      dialogTitle: '新增号码记录',
      isEditMode: false,
      searchForm: {
        keyword: ''
      },
      recordForm: {
        id: null,
        name: '',
        phone_number: '',
        wechat: '',
        qq: '',
        email: '',
        description: '',
        status: 1,
        notes: '',
        category_id: this.categoryId,
        store_id: this.storeId
      },
      formRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      },
      recordList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.fetchRecordList();
  },
  methods: {

    // 添加预览方法
    previewImportData() {
      if (this.importData.length === 0) {
        this.$message.warning('没有可预览的数据');
        return;
      }

      this.previewData = this.importData.slice(0, 10); // 只预览前10条
      this.previewDialogVisible = true;
    },
    // 获取记录列表
    async fetchRecordList() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.keyword ? 'search' : 'list',
          store_id: this.storeId,
          user_id: this.userId,  // 添加 user_id
          category_id: this.categoryId,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        if (this.searchForm.keyword) {
          params.keyword = this.searchForm.keyword;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/pc/api/number_management_record.php`,
          params
        );

        if (data.data) {
          this.recordList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取号码记录失败');
        console.error('获取号码记录错误:', error);
      } finally {
        this.loading = false;
      }
    },
    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchRecordList();
    },
    // 打开新增对话框
    openAddDialog() {
      this.dialogTitle = '新增号码记录';
      this.isEditMode = false;
      this.recordForm = {
        id: null,
        name: '',
        phone_number: '',
        wechat: '',
        qq: '',
        email: '',
        description: '',
        status: 1,
        notes: '',
        category_id: this.categoryId,
        store_id: this.storeId,
        user_id: this.userId  // 添加 user_id
      };
      this.dialogVisible = true;
    },
    // 打开编辑对话框
    openEditDialog(row) {
      this.dialogTitle = '编辑号码记录';
      this.isEditMode = true;
      this.recordForm = {
        id: row.id,
        name: row.name,
        phone_number: row.phone_number,
        wechat: row.wechat,
        qq: row.qq,
        email: row.email,
        description: row.description,
        status: row.status,
        notes: row.notes,
        category_id: this.categoryId,
        store_id: this.storeId,
        user_id: this.userId  // 添加 user_id
      };
      this.dialogVisible = true;
    },
    // 提交表单（新增/编辑）
    submitRecordForm() {
      this.$refs.recordForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add';
            const { data } = await axios.post(
              `${config.BASE_URL}/pc/api/number_management_record.php`,
              {
                action,
                ...this.recordForm,
                user_id: this.userId  // 添加 user_id
              }
            );

            if (data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchRecordList();
            } else {
              this.$message.error(data.error || '操作失败');
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '操作失败';
            this.$message.error(`操作失败: ${errorMsg}`);
            console.error('表单提交错误:', error);
          }
        }
      });
    },
    // 删除记录
    async handleDelete(id) {
      this.$confirm('确定要删除该号码记录吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/pc/api/number_management_record.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.storeId,
              user_id: this.userId  // 添加 user_id
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchRecordList();
          } else {
            this.$message.error(data.error || '删除失败');
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '删除失败';
          this.$message.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    },
    // 增加使用次数
    async handleIncrementUse(row) {
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/pc/api/number_management_record.php`,
          {
            action: 'increment_use',
            id: row.id,
            store_id: this.storeId,
            user_id: this.userId  // 添加 user_id
          }
        );

        if (data.success) {
          this.$message.success('使用次数已更新');
          this.fetchRecordList();
        } else {
          this.$message.error(data.error || '更新失败');
        }
      } catch (error) {
        const errorMsg = error.response?.data?.error || error.message || '更新失败';
        this.$message.error(`更新失败: ${errorMsg}`);
        console.error('更新使用次数错误:', error);
      }
    },
    // 打开批量导入对话框
    openBatchImportDialog() {
      this.importDialogVisible = true;
      this.importActiveTab = 'excel';
      this.importFile = null;
      this.importData = [];
      if (this.$refs.excelUploadRef) {
        this.$refs.excelUploadRef.clearFiles();
      }
    },
    // 处理Excel文件变化
    // 处理Excel文件变化
    handleExcelChange(file) {
      this.importFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);

        this.importData = jsonData.map(item => ({
          name: item['名称'] || item['name'] || '',
          phone_number: item['手机号'] || item['phone_number'] || '',
          wechat: item['微信号'] || item['wechat'] || '',
          qq: item['QQ号'] || item['qq'] || '',
          email: item['邮箱'] || item['email'] || '',
          description: item['描述'] || item['description'] || '',
          notes: item['备注'] || item['notes'] || ''
        })).filter(item =>
          // 放宽验证：只要有任意一个主要字段就允许导入
          item.name || item.phone_number || item.wechat || item.qq || item.email
        );

        if (this.importData.length === 0) {
          this.$message.warning('没有找到有效的数据，请检查Excel文件格式');
        }
      };
      reader.readAsArrayBuffer(file.raw);
    },
    // 下载Excel模板
    // 下载Excel模板
    downloadTemplate() {
      // 创建工作簿
      const wb = XLSX.utils.book_new();

      // 创建数据 - 展示不同情况的示例
      const templateData = [
        {
          '名称': '张三',
          '手机号': '13800138000',
          '微信号': 'zhangsan123',
          'QQ号': '123456789',
          '邮箱': 'zhangsan@example.com',
          '描述': '客户张三',
          '备注': '重要客户'
        },
        {
          '名称': '仅微信号',
          '手机号': '',
          '微信号': 'wechat_only',
          'QQ号': '',
          '邮箱': '',
          '描述': '只有微信号的记录',
          '备注': ''
        },
        {
          '名称': '仅手机号',
          '手机号': '13900139000',
          '微信号': '',
          'QQ号': '',
          '邮箱': '',
          '描述': '只有手机号的记录',
          '备注': ''
        },
        {
          '名称': '仅邮箱',
          '手机号': '',
          '微信号': '',
          'QQ号': '',
          '邮箱': 'email@example.com',
          '描述': '只有邮箱的记录',
          '备注': ''
        }
      ];

      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(templateData);

      // 设置列宽
      ws['!cols'] = [
        { wch: 15 },  // 名称
        { wch: 15 },  // 手机号
        { wch: 15 },  // 微信号
        { wch: 12 },  // QQ号
        { wch: 20 },  // 邮箱
        { wch: 20 },  // 描述
        { wch: 15 }   // 备注
      ];

      // 添加工作表到工作簿
      XLSX.utils.book_append_sheet(wb, ws, "号码数据");

      // 生成Excel文件并下载
      XLSX.writeFile(wb, '号码批量导入模板.xlsx');
    },
    // 提交批量导入
    async submitBatchImport() {
      if (this.importData.length === 0) {
        this.$message.warning('没有可导入的数据');
        return;
      }

      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/pc/api/number_management_record.php`,
          {
            action: 'batch_import',
            store_id: this.storeId,
            user_id: this.userId,  // 添加 user_id
            category_id: this.categoryId,
            batch: this.importData
          }
        );

        if (data.success) {
          this.$message.success(`成功导入 ${data.imported_count} 条记录`);
          this.importDialogVisible = false;
          this.fetchRecordList();
        } else {
          this.$message.error(data.error || '导入失败');
        }
      } catch (error) {
        this.$message.error('导入失败: ' + (error.response?.data?.error || error.message));
        console.error('导入错误:', error);
      }
    }
  }
}
</script>

<style scoped>
.record-list-container {
  padding: 20px;

  .search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 16px;
    background: #f8fafc;
    border-radius: 8px;
  }

  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  /* 操作按钮样式 */
  .el-button {
    display: inline-flex;
    align-items: center;

    .el-icon {
      margin-right: 5px;
    }
  }
}
</style>